import {
    AutoRefreshTokenService,
    createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    IncludeBearerTokenCondition,
    provideKeycloak, UserActivityService,
    withAutoRefreshToken
} from "keycloak-angular";
import {environment} from "../../../environments/environment";

export const provideKeycloakAndInterceptor = () => {
    const urlConditions = [
        createInterceptorCondition<IncludeBearerTokenCondition>({
                // Public queue endpoints must stay anonymous (TV display, join page).
                urlPattern: new RegExp(`^${environment.API_URL}\/(?!api\/queue\/(join|serving|stream|get\/.*)$).*$`, 'i'),
                bearerPrefix: 'Bearer',
            },
        ),
    ];

    const { identityServerUrl, clientId, realm } = environment.auth;

    return [
        provideKeycloak({
            config: {
                url: identityServerUrl,
                realm: realm,
                clientId: clientId
            },
            initOptions: {
                onLoad: 'check-sso',
                checkLoginIframe: true,
            },
            features: [
                withAutoRefreshToken({
                    sessionTimeout: 12*300000, // 1 hour idle timeout
                    // onInactivityTimeout: 'logout',
                }),
            ],
            providers: [
                AutoRefreshTokenService,
                UserActivityService,
            ],
        }),
        { provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, useValue: urlConditions },
    ];
};
